<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("WEEKLY_REPORTS.WEEKLY_REPORTS_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <help-button context="weekly-reports" />
              <!-- Add ZIP download button -->
              <!-- <base-button
                type="success"
                icon
                size="sm"
                class="mr-2"
                @click="showZipDownloadModal"
                v-if="
                  $currentUserCan($permissions.PERM_VIEW_ANY_WEEKLY_REPORTS)
                "
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-download"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("WEEKLY_REPORTS.DOWNLOAD_REPORTS_ZIP") }}
                </span>
              </base-button> -->

              <base-button
                type="primary"
                icon
                size="sm"
                @click="addWeeklReport()"
                v-if="
                  $currentUserCan($permissions.PERM_CREATE_WEEKLY_REPORTS) &&
                  $currentUserDoesWeeklyReports()
                "
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("WEEKLY_REPORTS.ADD_WEEKLY_REPORT") }}
                </span>
              </base-button>
            </div>
          </div>
        </template>
        <weekly-report-list-table
          :filterEstablishment="$route.query.establishment || null"
        />
      </card>
    </div>

    <!-- Add date range selection modal -->
    <modal :show="zipModalVisible" @close="closeZipModal">
      <template slot="header">
        <h5 class="modal-title">
          {{ $t("WEEKLY_REPORTS.SELECT_DATE_RANGE") }}
        </h5>
      </template>
      <div class="p-3">
        <base-input :label="$t('WEEKLY_REPORTS.STARTS_AT')">
          <flat-picker
            :config="{
              allowInput: true,
              allowInput: true,
              enableTime: false,
              dateFormat: 'Y-m-d',

              locale: $flatPickrLocale(),
            }"
            class="form-control datepicker"
            v-model="zipDateRange.startDate"
          >
          </flat-picker>
        </base-input>
        <base-input :label="$t('WEEKLY_REPORTS.ENDS_AT')">
          <flat-picker
            :config="{
              allowInput: true,
              allowInput: true,
              enableTime: false,
              dateFormat: 'Y-m-d',

              locale: $flatPickrLocale(),
            }"
            class="form-control datepicker"
            v-model="zipDateRange.endDate"
          >
          </flat-picker>
        </base-input>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="closeZipModal">
          {{ $t("COMMON.CANCEL") }}
        </base-button>
        <base-button
          type="primary"
          @click="downloadReportsZip"
          :disabled="!zipDateRange.startDate || !zipDateRange.endDate"
          :loading="downloadingZip"
        >
          {{ $t("COMMON.DOWNLOAD") }}
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Button } from "element-ui";
import WeeklyReportListTable from "./partials/WeeklyReportListTable.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { Modal } from "@/components";

export default {
  layout: "DashboardLayout",

  components: {
    WeeklyReportListTable,
    [Button.name]: Button,
    flatPicker,
    Modal,
  },

  mixins: [],

  computed: {},

  watch: {},

  data() {
    return {
      zipModalVisible: false,
      zipDateRange: {
        startDate: moment().startOf('week').format("YYYY-MM-DD"),
        endDate: moment().endOf('week').format("YYYY-MM-DD"),
      },
      downloadingZip: false,
    };
  },

  methods: {
    addWeeklReport() {
      this.$router.push({ name: "Add WeeklyReport" });
    },

    // New methods for ZIP download
    showZipDownloadModal() {
      this.zipModalVisible = true;
    },

    closeZipModal() {
      this.zipModalVisible = false;
    },

    async downloadReportsZip() {
      try {
        this.downloadingZip = true;

        // Call the API through the store with AJAX
        const response = await this.$store.dispatch(
          "weeklyReports/downloadZip",
          {
            start_date: this.zipDateRange.startDate,
            end_date: this.zipDateRange.endDate,
          }
        );

        // Use the blob URL to download the file
        this.initiateDownload(response.url, response.filename);
        
        this.downloadingZip = false;
        this.zipModalVisible = false;

        // Success notification
        this.$notify({
          type: "success",
          message: this.$t("WEEKLY_REPORTS.DOWNLOAD_COMPLETED"),
        });
      } catch (error) {
        this.downloadingZip = false;
        console.error("Error downloading reports:", error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.DOWNLOAD_FAILED"),
        });
      }
    },

    // Updated method to handle direct download
    initiateDownload(url, filename) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // Free up memory
      }, 100);
    },
  },
};
</script>
